module.exports = __webpack_public_path__ + "images/emoji/uk.0b19adfa46db5112d021.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/uk.png
// module id = pRDk
// module chunks = 1